<template>
    <div>
        <!-- SVG Gradient Definitions -->
        <svg width="0" height="0" style="position:absolute">
            <defs>
                <linearGradient id="gradient0" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#3D57FF" />
                    <stop offset="100%" stop-color="#3C1AEA" />
                </linearGradient>
                <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#3DB5FF" />
                    <stop offset="100%" stop-color="#1A4BEA" />
                </linearGradient>
                <linearGradient id="gradient2" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#00A44C" />
                    <stop offset="100%" stop-color="#034E00" />
                </linearGradient>
                <linearGradient id="gradient3" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stop-color="#00A18E" />
                    <stop offset="100%" stop-color="#005768" />
                </linearGradient>
                <linearGradient id="gradient4" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="21.02%" stop-color="#04A8AB" />
                    <stop offset="99%" stop-color="#004385" />
                </linearGradient>
            </defs>
        </svg>

        <ModalTitle :bodyStyle="{ 'padding': '0px 25px 30px' }" :model-value="modelValue" :backdrop="backdrop"
            @update:model-value="onModelValue">
            <template #header>
                <div class="text-[24px] text-white font-[800] leading-[40px] tracking-[0.25px]">
                    {{ $t('niuniu.trendChart') }}</div>
            </template>

            <div class="content-container">

                <!-- 数据展示 -->
                <div class="relative overflow-hidden">
                    <div class="split-line left-[20%]"></div>
                    <div class="split-line left-[40%]"></div>
                    <div class="split-line left-[60%]"></div>
                    <div class="split-line left-[80%]"></div>
                    <!-- 统计百分比 -->
                    <div class="flex items-center"
                        style="border: 1px solid var(--color_grey-40);border-radius: 12px 12px 0px 0px;">
                        <div class="text-center w-[20%] relative"
                            :class="['header' + index]"
                            v-for="(item, index) in headers" :key="index">

                            <div class="flex items-center justify-center py-[9px] px-[13px]"
                                style="background-color: '#0D131C';">
                                <q-circular-progress reverse show-value :value="item.percent" class="trend-circle"
                                    :class="'trend-circle' + index" size="40px"
                                    :style="{ '--track-color': item.trackColor }">
                                    <div class="text-center">
                                        <div :class="index == 0 ? 'text-green' : 'text-white'"
                                            class="text-[10px] font-[600] leading-[12px] mb-1">{{ item.name
                                            }}</div>
                                        <div class="text-[10px] text-[#93ACD3] leading-[10px] font-[500]">{{
                                            item.percent }}%</div>
                                    </div>
                                </q-circular-progress>
                            </div>
                        </div>
                    </div>

                    <div class="list" :loading="loading">
                        <ul v-if="roundHistory.length">
                            <li :class="index == 0 ? 'border-blue relative' : ''" class="flex items-center"
                                v-for="(item, index) in roundHistory" :key="index">
                                <span v-if="index == 0" class="new">New</span>
                                <!-- 庄家结果 -->
                                <div class="text-center flex items-center justify-center gap-x-[2px]">
                                    <template v-if="Number(item.bankerNiuType) === 11">
                                        <span :class="{
                                            '!text-[#1BB83D]': item.bankerStatus === 'win',
                                            '!text-[11px] !leading-[12px]':locale !== 'cn'
                                        }">
                                            {{ formatNiuType(item.bankerNiuType) }}
                                        </span>
                                        <IconSvgUse v-if="item.bankerStatus === 'win'" use="icon-cow-green"
                                            style="color: #1BB83D" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse v-else use="icon-cow-red"
                                            style="color: #ED1D49" class="w-[14px] h-[14px] duration-100" />
                                    </template>
                                    <template v-else-if="Number(item.bankerNiuType) === 12">
                                        <span :class="{
                                            '!text-[#1BB83D]': item.bankerStatus === 'win',
                                            '!text-[11px] !leading-[12px]':locale !== 'cn'
                                        }">
                                            {{ formatNiuType(item.bankerNiuType) }}
                                        </span>
                                    </template>

                                    <template v-else-if="Number(item.bankerNiuType) === 13">
                                        <span :class="{
                                            '!text-[#1BB83D]': item.bankerStatus === 'win',
                                            '!text-[11px] !leading-[12px]':locale !== 'cn'
                                        }" v-html="locale === 'cn' ? '五小' : 'Five<br>Small'">
                                        </span>
                                        <IconSvgUse v-if="item.bankerStatus === 'win'" use="icon-cow-green"
                                            style="color: #1BB83D" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse v-else use="icon-cow-red"
                                            style="color: #ED1D49" class="w-[14px] h-[14px] duration-100" />
                                    </template>

                                    <template v-else>
                                        <IconSvgUse v-if="Number(item.bankerNiuType) === 10" use="icon-cow-red"
                                            style="color: #ED1D49" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse
                                            v-else-if="Number(item.bankerNiuType) !== 10 && item.bankerStatus === 'win'"
                                            use="icon-cow-green" style="color: #1BB83D" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse v-else use="icon-cow" class="w-[14px] h-[14px] duration-100" />
                                        <span :class="{
                                            '!text-[#ED1D49]': Number(item.bankerNiuType) === 10,
                                            '!text-[#1BB83D]': Number(item.bankerNiuType) !== 10 && item.bankerStatus === 'win'
                                        }">
                                            {{ formatNiuType(item.bankerNiuType) }}
                                        </span>
                                    </template>

                                </div>

                                <!-- 天地玄黄结果 -->
                                <div v-for="sector in areaIds" :key="sector"
                                    class="text-center flex items-center justify-center gap-x-[2px]">
                                    <!-- 五花牛 -->
                                    <template v-if="Number(item.sectorResults[sector].niuType) === 11">
                                        <span :class="{
                                            '!text-[#1BB83D]': item.sectorResults[sector].status === 'win',
                                            '!text-[11px] !leading-[12px]':locale !== 'cn'
                                        }">
                                            {{ formatNiuType(item.sectorResults[sector].niuType) }}
                                        </span>
                                        <IconSvgUse v-if="item.sectorResults[sector].status === 'win'" use="icon-cow-green"
                                            style="color: #1BB83D" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse v-else use="icon-cow-red"
                                            style="color: #ED1D49" class="w-[14px] h-[14px] duration-100" />
                                    </template>
                                    <!-- 四炸 -->
                                    <template v-else-if="Number(item.sectorResults[sector].niuType) === 12">
                                        <span :class="{
                                            '!text-[#1BB83D]': item.sectorResults[sector].status === 'win',
                                            '!text-[11px] !leading-[12px]':locale !== 'cn'
                                        }">
                                            {{ formatNiuType(item.sectorResults[sector].niuType) }}
                                        </span>
                                    </template>
                                    <!-- 五小牛 -->
                                    <template v-else-if="Number(item.sectorResults[sector].niuType) === 13">
                                        <span :class="{
                                            '!text-[#1BB83D]': item.sectorResults[sector].status === 'win',
                                            '!text-[11px] !leading-[12px]':locale !== 'cn'
                                        }" v-html="locale === 'cn' ? '五小' : 'Five<br>Small'">
                                        </span>
                                        <IconSvgUse v-if="item.sectorResults[sector].status === 'win'" use="icon-cow-green"
                                            style="color: #1BB83D" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse v-else use="icon-cow-red"
                                            style="color: #ED1D49" class="w-[14px] h-[14px] duration-100" />
                                    </template>
                                    <!-- 其他牌型 -->
                                    <template v-else>
                                        <IconSvgUse v-if="Number(item.sectorResults[sector].niuType) === 10" use="icon-cow-red"
                                            style="color: #ED1D49" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse
                                            v-else-if="Number(item.sectorResults[sector].niuType) !== 10 && item.sectorResults[sector].status === 'win'"
                                            use="icon-cow-green" style="color: #1BB83D" class="w-[14px] h-[14px] duration-100" />
                                        <IconSvgUse v-else use="icon-cow" class="w-[14px] h-[14px] duration-100" />
                                        <span :class="{
                                            '!text-[#ED1D49]': Number(item.sectorResults[sector].niuType) === 10,
                                            '!text-[#1BB83D]': Number(item.sectorResults[sector].niuType) !== 10 && item.sectorResults[sector].status === 'win'
                                        }">
                                            {{ formatNiuType(item.sectorResults[sector].niuType) }}
                                        </span>
                                    </template>
                                </div>
                            </li>
                        </ul>

                        
                    </div>
                </div>
                <!-- 分页控制 -->
                <div class="history-pagination" v-if="roundHistory.length > 0">
                    <q-pagination v-model="params.page"
                        :max="Math.min(Math.ceil(count / iRows) || totalPages, 99)" :max-pages="4"
                        boundary-numbers color="#55657e" active-color="#2281f6" direction-links
                        @update:model-value="onPageChange" />
                </div>
                <Empty v-else>
                    <img width="134" height="132" src="@/assets/imgs/casino/no-data-image.webp" alt="">
                </Empty>
            </div>
        </ModalTitle>

    </div>
</template>

<script setup lang="ts">
import { useNiuNiu, type NiuniuRoundHistoryParams } from '~/socket/game/niuniu';
import { getTables } from '~/pages/casino/niuniuGame/ts/niuniuCommon';
import { formatNiuTypeForDisplay } from '~/pages/casino/niuniuGame/ts/gameTps';

// 区域列表：天地玄黄（从配置中动态获取英文名称）
const areaIds = computed(() => {
    const tables = getTables();
    return tables.map(table => table.name); // 返回英文名称数组：['tian', 'di', 'xuan', 'huang']
});

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
    hallName: {
        type: String,
        default: 'trial'
    }
});

const emit = defineEmits(['update:modelValue']);
const onModelValue = (value) => {
    emit('update:modelValue', value);
};
const { t: $tFn, locale } = useNuxtApp().$i18n;
// 监听弹窗打开，加载历史数据
watch(() => props.modelValue, (newVal) => {
    if (newVal) {
        loadRoundHistory();
    }
});

// 分页参数
const params = ref({
    page: 1,
    limit: 20
});

// 历史记录数据
const roundHistory = ref<any[]>([]);
const totalItems = ref(0);
const totalPages = ref(0);
const iRows = ref(20); // 常量，后端人员声明的，固定的每页行数
const count = ref(0) //历史记录总数居
const loading = ref(false)

// 获取游戏历史记录数据
const { EMIT_NIUNIU_ROUND_HISTORY } = useNiuNiu();

// 加载历史记录数据
const loadRoundHistory = () => {
    loading.value = true
    // 创建请求参数
    const requestParams: NiuniuRoundHistoryParams = {
        hallName: props.hallName,
        page: params.value.page,
        limit: params.value.limit
    };

    // 使用回调式调用socket方法
    EMIT_NIUNIU_ROUND_HISTORY(requestParams, (res: any) => {
        loading.value = false
        if (!res || res['error'] || !res['rounds']) {
            return;
        }
        if (Array.isArray(res.rounds)) {
            // 更新历史记录数据
            roundHistory.value = res.rounds;
            count.value = Number(res.count || 0);
            updateStatistics()

            // 更新分页相关数据
            if (res.pagination) {
                iRows.value = res.pagination.limit || iRows.value;
                totalItems.value = res.pagination.total || 0;
                totalPages.value = res.pagination.totalPages || 1;
            }
        }
    });
};

// 更新统计数据
const updateStatistics = () => {
    if (!roundHistory.value.length) return;

    const total = roundHistory.value.length;
    let bankerWinCount = 0;
    let tianWinCount = 0;
    let diWinCount = 0;
    let xuanWinCount = 0;
    let huangWinCount = 0;

    // 统计赢牌次数
    roundHistory.value.forEach(round => {
        if (round.bankerStatus === 'win') bankerWinCount++;

        if (round.winningSectors.includes('tian')) tianWinCount++;
        if (round.winningSectors.includes('di')) diWinCount++;
        if (round.winningSectors.includes('xuan')) xuanWinCount++;
        if (round.winningSectors.includes('huang')) huangWinCount++;
    });
    // 更新统计百分比
    statistics.value[0].percent = Math.round((bankerWinCount / total) * 100);
    statistics.value[0].count = bankerWinCount;

    statistics.value[1].percent = Math.round((tianWinCount / total) * 100);
    statistics.value[1].count = tianWinCount;

    statistics.value[2].percent = Math.round((diWinCount / total) * 100);
    statistics.value[2].count = diWinCount;

    statistics.value[3].percent = Math.round((xuanWinCount / total) * 100);
    statistics.value[3].count = xuanWinCount;

    statistics.value[4].percent = Math.round((huangWinCount / total) * 100);
    statistics.value[4].count = huangWinCount;
};


// 格式化牛牛类型（中文时去掉第一个"牛"字，因为被图标代替）
const formatNiuType = (niuType: number): string => {
    return formatNiuTypeForDisplay(niuType, locale.value);
};

// 统计数据存储（独立于名称）
const statistics = ref([
    { percent: 0, count: 0 }, // 庄
    { percent: 0, count: 0 }, // 天
    { percent: 0, count: 0 }, // 地
    { percent: 0, count: 0 }, // 玄
    { percent: 0, count: 0 }, // 黄
]);

// 统计头部数据
const headers = computed(() => {
    const tables = getTables();

    // 获取区域名称的辅助函数
    const getTableName = (index: number) => {
        if (tables[index]) {
            return locale.value === 'cn' ? tables[index].nameCn : tables[index].name;
        }
        return '';
    };

    return [
        {
            name: $tFn('niuniu.zhuang'),
            percent: statistics.value[0].percent,
            count: statistics.value[0].count,
            trackColor: 'url(#gradient0)',
        },
        {
            name: getTableName(0), // 天
            percent: statistics.value[1].percent,
            count: statistics.value[1].count,
            trackColor: 'url(#gradient1)',
        },
        {
            name: getTableName(1), // 地
            percent: statistics.value[2].percent,
            count: statistics.value[2].count,
            trackColor: 'url(#gradient2)',
        },
        {
            name: getTableName(2), // 玄
            percent: statistics.value[3].percent,
            count: statistics.value[3].count,
            trackColor: 'url(#gradient3)',
        },
        {
            name: getTableName(3), // 黄
            percent: statistics.value[4].percent,
            count: statistics.value[4].count,
            trackColor: 'url(#gradient4)',
        },
    ];
});

// 分页切换处理
const onPageChange = (page) => {
    if (page !== params.value.page) {
        params.value.page = page;
        loadRoundHistory();
    } else {
        // 即使是同一页也刷新数据，确保数据最新
        loadRoundHistory();
    }
    // 滚动到列表顶部，提升用户体验
    const listElement = document.querySelector('.list ul');
    if (listElement) {
        listElement.scrollTop = 0;
    }
};

// 暴露方法给父组件
defineExpose({
    loadRoundHistory, // 刷新走势图数据
});
</script>
<style lang="scss" scoped>
.content-container {
    max-height: 490px;
    height: 490px;
    overflow-y: auto;
    position: relative;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

// 分页控制样式
.history-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    :deep(.q-pagination) {
        button {
            background: #545c6c40;
            color: #55657e;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 600;
            height: 35px;
            min-width: 35px !important;
            margin: 0 2px;
        }

        .q-btn--standard {
            background: #2281f6;
            font-size: 15px;
        }
    }
}

.split-line {
    width:1px;
    height:100%;
    position: absolute;
    top:0;
    border-right: 1px solid var(--color_grey-40);
}

.new {
    padding: 2px 8px;
    border-radius: 2px 2px 8px 2px;
    background: var(--color_blue);
    font-weight: 800;
    font-size: 10px;
    line-height: 10px;
    color: white;
    position: absolute;
    top: 0px;
    left: 0px;
}

.list {
    ul {
        border-radius: 0px 0px 12px 12px;
        border: 1px solid var(--color_grey-40);

        li {
            border-bottom: 1px solid var(--color_grey-40);
            div {
                width: 20%;
                padding: 13px 0px;

                span {
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 14px;
                    letter-spacing: 0.25px;
                    color: #93ACD3;
                }
            }

            div:last-child {
                border-right: none;
            }
        }

        li:first-of-type {
            border: 1px solid var(--color_blue);
        }

        li:last-child {
            border-bottom: none;
        }
    }
}

.border-blue {
    border: 1px solid var(--color_blue);
}

:deep(.q-circular-progress) {
    position: relative;
    display: inline-flex;
    border-radius: 50%;
    padding: 3px;
}

:deep(.q-circular-progress__circle) {
    stroke-width: 3px;
}

.trend-circle {
    width: 40px !important;
    height: 40px !important;
    padding: 0px;

    :deep(.q-circular-progress__svg) {
        border-radius: 50%;
    }
}

.trend-circle0 {
    :deep(.q-circular-progress__svg) {
        background-color: #1C2532;
    }

    :deep(.q-circular-progress__circle) {
        stroke-width: 3px;
        stroke: url(#gradient0) !important;
    }
}

.trend-circle1 {
    :deep(.q-circular-progress__svg) {
        background-color: #083E8E;
    }

    :deep(.q-circular-progress__circle) {
        stroke-width: 3px;
        stroke: url(#gradient1) !important;
    }
}

.trend-circle2 {
    :deep(.q-circular-progress__svg) {
        background-color: #003725;
    }

    :deep(.q-circular-progress__circle) {
        stroke-width: 3px;
        stroke: url(#gradient2) !important;
    }
}

.trend-circle3 {
    :deep(.q-circular-progress__svg) {
        background-color: #00474F;
    }

    :deep(.q-circular-progress__circle) {
        stroke-width: 3px;
        stroke: url(#gradient3) !important;
    }
}

.trend-circle4 {
    :deep(.q-circular-progress__svg) {
        background-color: #002E4F;
    }

    :deep(.q-circular-progress__circle) {
        stroke-width: 3px;
        stroke: url(#gradient4) !important;
    }
}

.header0 {
    .progress-mask {
        mask: radial-gradient(transparent calc(50% - 10px),
                /* 根据 thickness 调整 */
                black calc(50% - 9px)) !important;
        background: transparent !important;
    }
}
</style>